/**
 * Base URL for uploaded files: Azure blob when REACT_APP_STORAGE_TYPE=azure,
 * otherwise the API public URL (local/public disk).
 */
export const STORAGE_PUBLIC_BASE =
  process.env.REACT_APP_STORAGE_TYPE === "azure"
    ? process.env.REACT_APP_STORAGE_URL
    : process.env.REACT_APP_API_PUBLIC_URL;
